// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import { fetchUpdates, getUserInfo } from 'backend/schoologyApi';
import { getTimezone } from 'public/functions';

async function fillinpictures() {
    let repeater = $w("#repeater1");
    let data = repeater.data;
    let uids = {};
    for (var i in data) {
        var entry = data[i]
        if (entry.uid in uids) {
            var u = uids[entry.uid];
        } else {
            var u = await getUserInfo(entry.uid);
            uids[entry.uid] = u;
        }
        if (!(u == undefined)) {
            repeater.forItems([entry["_id"]], ($item, itemData, index) => {
                $item("#author").text = u[0];
                $item("#pfp").src = u[1];
            });
        }
    }
}

async function prepare() {
    let repeater = $w("#repeater1");
    let data = await fetchUpdates(getTimezone());
    if (data) {
        repeater.data = data;
        repeater.onItemReady(($item, itemData, index) => {
            $item("#body").text = itemData.body;
            $item("#author").text = itemData.author;
            $item("#date").text = itemData.date;
        });
    }
    $w("#loading").hide();
    repeater.show();
    fillinpictures();
}
const delay = ms => new Promise(res => setTimeout(res, ms));

async function loadingtext() {
    while ($w("#loading").isVisible) {
        let text = $w("#loading").text;
        await delay(500);
        if (text.split(".").length < 4) {
            $w("#loading").text += ".";
        } else {
            $w("#loading").text = text.slice(0, -3);
        }
    }
    console.log("Loading Finished!");
}

$w.onReady(function () {
    $w("#repeater1").hide();
    loadingtext()
    prepare();
});